export default "__VITE_ASSET__a598a307__"